export default __webpack_public_path__ + "static/media/Naim.9e571c29.jpg";